var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserCouple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM.02 21h13.96l.02-.5c0-3.59-3.13-6.5-7-6.5s-7 2.91-7 6.5c0 .17 0 .34.02.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.28 13.66a7.5 7.5 0 0 1 4.7 7.34H24v-5.5c0-3.59-3.13-6.5-7-6.5a6.95 6.95 0 0 0-6.72 4.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserCouple);
export default ForwardRef;